var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSlider',{attrs:{"lazy":true,"adsorb":_vm.adsorb,"tooltip":_vm.tooltip,"data":_vm.data,"dotSize":_vm.dotSize,"processStyle":_vm.processStyle,"railStyle":_vm.railStyle,"value":_vm.currentValue},on:{"change":_vm.onChangeCurrentValue}})}
var staticRenderFns = []

export { render, staticRenderFns }